import { Alert } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";

export const UnsavedIndicator: FC<{ isDirty: boolean }> = ({ isDirty }) => {
  const [dirtyTime, setDireditTime] = useState<number | null>(null);
  const [date, setDate] = useState<number | null>(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setDireditTime(isDirty ? Date.now() : null);
  }, [isDirty]);

  useEffect(() => {
    const timerID = setInterval(() => setDate(Date.now()), 10000);
    return () => clearInterval(timerID);
  }, []);

  const ago = date && dirtyTime ? Math.round((date - dirtyTime) / 1000 / 60) : 0;
  return ago > 2 ? (
    <Alert severity="warning" title="Save your work regularly to avoid losing your changes">
      Last saved {ago} minutes ago
    </Alert>
  ) : (
    <></>
  );
};
